import { Observable, type Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import { mutation$ } from '@atlassian/jira-software-swag/src/services/mutation/index.tsx';
import type { SprintState } from '../../model/types.tsx';

export type Sprint = {
	canUpdateSprint: boolean;
	daysRemaining: number;
	isoEndDate: string;
	id: number;
	name: string;
	isoStartDate: string;
	state: SprintState;
};

const MUTATION_NAME = 'BacklogCreateSprint';

export const getMutation = (boardId: string) =>
	`mutation ${MUTATION_NAME} {
        createSprint(input: { 
            boardId: ${boardId}
        }) {
            sprint {
                id,
                name,
                daysRemaining,
                startDate,
                endDate,
                sprintState,
                canUpdateSprint
            }
        }
    }`;

type Result = {
	createSprint: {
		sprint: {
			canUpdateSprint: boolean;
			daysRemaining: number;
			endDate: string;
			id: number;
			name: string;
			startDate: string;
			sprintState: SprintState;
		};
	};
};

export const convert = (result: Result): ObservableType<Sprint> => {
	const { sprintState, endDate, startDate, ...rest } = result.createSprint.sprint;
	const createdSprint = {
		...rest,
		state: sprintState,
		isoEndDate: endDate === 'None' ? '' : endDate,
		isoStartDate: startDate === 'None' ? '' : startDate,
	};

	return Observable.of(createdSprint);
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, boardId: string): ObservableType<Sprint> =>
	mutation$<Result>(baseUrl, MUTATION_NAME, getMutation(boardId)).flatMap(convert);
